import styled from '@emotion/styled';
import {
  MenuButton,
  Dropdown,
  MenuItem,
  MenuGroup,
  MenuGroupHeader,
  Badge,
} from '@fluentui/react-components';

export const CustomMenuButton = styled(MenuButton)`
  width: 260px;
  justify-content: space-between !important;
`;

export const CustomMenuButtonDataSet = styled(CustomMenuButton)`
  white-space: nowrap;
`;

export const SettingsListWrapper = styled(Dropdown)`
  min-width: 200px;
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
  display: block;
`;

export const CustomMenuGroup = styled(MenuGroup)`
  margin: 0;
  padding: 0;
`;

export const CustomMenuGroupHeader = styled(MenuGroupHeader)`
  margin-top: 10px;
`;

export const CustomMenuItem = styled(MenuItem)`
  margin-top: ${(props) => (props.isUncategorized ? '10px' : '0')};
  min-width: 250px;
`;

export const MenuLabelWrapper = styled.span`
  margin-right: 10px;
`;

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const MenuHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 0.5rem;
  margin-right: 0.5rem;
  text-transform: uppercase;
  width: 100%;
`;

export const MenuItemFull = styled(MenuItem)`
  max-width: inherit !important;
`;

export const DatasetMenuItem = styled(MenuItem)`
  max-width: inherit !important;

  .fui-MenuItem__content {
    display: flex;
    align-items: center;
    column-gap: 0.5rem;
  }
`;

export const CustomBadge = styled(Badge)`
  background-color: ${(props) => (props.warning ? '#ffc107' : '#2196f3')};
  color: ${(props) => (props.warning ? '#000' : '#fff')};
  font-weight: 400;
  width: 160px;
`;
